export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  jsonb: any;
  numeric: any;
  timestamptz: Date | string;
  uuid: string;
};


/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
};

export type DeleteAccountOutput = {
  __typename?: 'DeleteAccountOutput';
  status: Scalars['Boolean'];
};

export type GenerateReportOutput = {
  __typename?: 'GenerateReportOutput';
  fileName: Scalars['String'];
  report_url: Scalars['String'];
  s3_key: Scalars['String'];
};

export type GetIgGInColostrumReplacerOutput = {
  __typename?: 'GetIgGInColostrumReplacerOutput';
  igGInColostrumReplacer: Scalars['Int'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
};

export enum ModuleRequestAccessEnum {
  CalfMilkRation = 'calf_milk_ration',
  ColostrumReplacer = 'colostrum_replacer'
}

export type ModuleRequestAccessOutput = {
  __typename?: 'ModuleRequestAccessOutput';
  status: Scalars['Boolean'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>;
};

/** columns and relationships of "calculation" */
export type Calculation = {
  __typename?: 'calculation';
  calculator: Enum_Calculator_Enum;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: User;
  created_by_id: Scalars['uuid'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  farm: Farm;
  farm_id: Scalars['uuid'];
  id: Scalars['uuid'];
  inputs: Scalars['jsonb'];
  name?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by: User;
  updated_by_id: Scalars['uuid'];
};


/** columns and relationships of "calculation" */
export type CalculationInputsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "calculation" */
export type Calculation_Aggregate = {
  __typename?: 'calculation_aggregate';
  aggregate?: Maybe<Calculation_Aggregate_Fields>;
  nodes: Array<Calculation>;
};

export type Calculation_Aggregate_Bool_Exp = {
  count?: Maybe<Calculation_Aggregate_Bool_Exp_Count>;
};

export type Calculation_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Calculation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Calculation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "calculation" */
export type Calculation_Aggregate_Fields = {
  __typename?: 'calculation_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Calculation_Max_Fields>;
  min?: Maybe<Calculation_Min_Fields>;
};


/** aggregate fields of "calculation" */
export type Calculation_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Calculation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "calculation" */
export type Calculation_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Calculation_Max_Order_By>;
  min?: Maybe<Calculation_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Calculation_Append_Input = {
  inputs?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "calculation" */
export type Calculation_Arr_Rel_Insert_Input = {
  data: Array<Calculation_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Calculation_On_Conflict>;
};

/** Boolean expression to filter rows from the table "calculation". All fields are combined with a logical 'AND'. */
export type Calculation_Bool_Exp = {
  _and?: Maybe<Array<Calculation_Bool_Exp>>;
  _not?: Maybe<Calculation_Bool_Exp>;
  _or?: Maybe<Array<Calculation_Bool_Exp>>;
  calculator?: Maybe<Enum_Calculator_Enum_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<User_Bool_Exp>;
  created_by_id?: Maybe<Uuid_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  farm?: Maybe<Farm_Bool_Exp>;
  farm_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  inputs?: Maybe<Jsonb_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_by?: Maybe<User_Bool_Exp>;
  updated_by_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "calculation" */
export enum Calculation_Constraint {
  /** unique or primary key constraint on columns "id" */
  CalculationPkey = 'calculation_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Calculation_Delete_At_Path_Input = {
  inputs?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Calculation_Delete_Elem_Input = {
  inputs?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Calculation_Delete_Key_Input = {
  inputs?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "calculation" */
export type Calculation_Insert_Input = {
  calculator?: Maybe<Enum_Calculator_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<User_Obj_Rel_Insert_Input>;
  created_by_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  farm?: Maybe<Farm_Obj_Rel_Insert_Input>;
  farm_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  inputs?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<User_Obj_Rel_Insert_Input>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Calculation_Max_Fields = {
  __typename?: 'calculation_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  farm_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "calculation" */
export type Calculation_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  farm_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Calculation_Min_Fields = {
  __typename?: 'calculation_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  farm_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "calculation" */
export type Calculation_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  farm_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "calculation" */
export type Calculation_Mutation_Response = {
  __typename?: 'calculation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Calculation>;
};

/** on_conflict condition type for table "calculation" */
export type Calculation_On_Conflict = {
  constraint: Calculation_Constraint;
  update_columns?: Array<Calculation_Update_Column>;
  where?: Maybe<Calculation_Bool_Exp>;
};

/** Ordering options when selecting data from "calculation". */
export type Calculation_Order_By = {
  calculator?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<User_Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  farm?: Maybe<Farm_Order_By>;
  farm_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  inputs?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<User_Order_By>;
  updated_by_id?: Maybe<Order_By>;
};

/** primary key columns input for table: calculation */
export type Calculation_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Calculation_Prepend_Input = {
  inputs?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "calculation" */
export enum Calculation_Select_Column {
  /** column name */
  Calculator = 'calculator',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmId = 'farm_id',
  /** column name */
  Id = 'id',
  /** column name */
  Inputs = 'inputs',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "calculation" */
export type Calculation_Set_Input = {
  calculator?: Maybe<Enum_Calculator_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  farm_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  inputs?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "calculation" */
export type Calculation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Calculation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Calculation_Stream_Cursor_Value_Input = {
  calculator?: Maybe<Enum_Calculator_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  farm_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  inputs?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "calculation" */
export enum Calculation_Update_Column {
  /** column name */
  Calculator = 'calculator',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmId = 'farm_id',
  /** column name */
  Id = 'id',
  /** column name */
  Inputs = 'inputs',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Calculation_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Calculation_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Calculation_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Calculation_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Calculation_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Calculation_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Calculation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Calculation_Bool_Exp;
};

/** columns and relationships of "calf" */
export type Calf = {
  __typename?: 'calf';
  birth_body_wt: Scalars['numeric'];
  col_rep_measurement_system_id: Enum_Measurement_System_Enum;
  /** Brix reading of colostrum fed in first feeding */
  colostrum_first_fdg_brix_reading: Scalars['numeric'];
  /** Desired Max volume of colostrum for first feeding */
  colostrum_max_first_fdg: Scalars['numeric'];
  /** Desired Max volume of colostrum for second feeding */
  colostrum_max_second_fdg: Scalars['numeric'];
  /** Brix reading of colostrum fed in second feeding */
  colostrum_second_fdg_brix_reading: Scalars['numeric'];
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  farm: Farm;
  farm_id: Scalars['uuid'];
  /** This is the calf id entered by the user */
  id: Scalars['String'];
  /** This is the auto-generated system id. */
  system_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "calf" */
export type Calf_Aggregate = {
  __typename?: 'calf_aggregate';
  aggregate?: Maybe<Calf_Aggregate_Fields>;
  nodes: Array<Calf>;
};

/** aggregate fields of "calf" */
export type Calf_Aggregate_Fields = {
  __typename?: 'calf_aggregate_fields';
  avg?: Maybe<Calf_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Calf_Max_Fields>;
  min?: Maybe<Calf_Min_Fields>;
  stddev?: Maybe<Calf_Stddev_Fields>;
  stddev_pop?: Maybe<Calf_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Calf_Stddev_Samp_Fields>;
  sum?: Maybe<Calf_Sum_Fields>;
  var_pop?: Maybe<Calf_Var_Pop_Fields>;
  var_samp?: Maybe<Calf_Var_Samp_Fields>;
  variance?: Maybe<Calf_Variance_Fields>;
};


/** aggregate fields of "calf" */
export type Calf_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Calf_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Calf_Avg_Fields = {
  __typename?: 'calf_avg_fields';
  birth_body_wt?: Maybe<Scalars['Float']>;
  /** Brix reading of colostrum fed in first feeding */
  colostrum_first_fdg_brix_reading?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for first feeding */
  colostrum_max_first_fdg?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for second feeding */
  colostrum_max_second_fdg?: Maybe<Scalars['Float']>;
  /** Brix reading of colostrum fed in second feeding */
  colostrum_second_fdg_brix_reading?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "calf". All fields are combined with a logical 'AND'. */
export type Calf_Bool_Exp = {
  _and?: Maybe<Array<Calf_Bool_Exp>>;
  _not?: Maybe<Calf_Bool_Exp>;
  _or?: Maybe<Array<Calf_Bool_Exp>>;
  birth_body_wt?: Maybe<Numeric_Comparison_Exp>;
  col_rep_measurement_system_id?: Maybe<Enum_Measurement_System_Enum_Comparison_Exp>;
  colostrum_first_fdg_brix_reading?: Maybe<Numeric_Comparison_Exp>;
  colostrum_max_first_fdg?: Maybe<Numeric_Comparison_Exp>;
  colostrum_max_second_fdg?: Maybe<Numeric_Comparison_Exp>;
  colostrum_second_fdg_brix_reading?: Maybe<Numeric_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  farm?: Maybe<Farm_Bool_Exp>;
  farm_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<String_Comparison_Exp>;
  system_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "calf" */
export enum Calf_Constraint {
  /** unique or primary key constraint on columns "id", "farm_id", "deleted_at" */
  CalfIdFarmIdDeletedAtKey = 'calf_id_farm_id_deleted_at_key',
  /** unique or primary key constraint on columns "system_id" */
  CalfPkey = 'calf_pkey'
}

/** input type for incrementing numeric columns in table "calf" */
export type Calf_Inc_Input = {
  birth_body_wt?: Maybe<Scalars['numeric']>;
  /** Brix reading of colostrum fed in first feeding */
  colostrum_first_fdg_brix_reading?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for first feeding */
  colostrum_max_first_fdg?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for second feeding */
  colostrum_max_second_fdg?: Maybe<Scalars['numeric']>;
  /** Brix reading of colostrum fed in second feeding */
  colostrum_second_fdg_brix_reading?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "calf" */
export type Calf_Insert_Input = {
  birth_body_wt?: Maybe<Scalars['numeric']>;
  col_rep_measurement_system_id?: Maybe<Enum_Measurement_System_Enum>;
  /** Brix reading of colostrum fed in first feeding */
  colostrum_first_fdg_brix_reading?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for first feeding */
  colostrum_max_first_fdg?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for second feeding */
  colostrum_max_second_fdg?: Maybe<Scalars['numeric']>;
  /** Brix reading of colostrum fed in second feeding */
  colostrum_second_fdg_brix_reading?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  farm?: Maybe<Farm_Obj_Rel_Insert_Input>;
  farm_id?: Maybe<Scalars['uuid']>;
  /** This is the calf id entered by the user */
  id?: Maybe<Scalars['String']>;
  /** This is the auto-generated system id. */
  system_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Calf_Max_Fields = {
  __typename?: 'calf_max_fields';
  birth_body_wt?: Maybe<Scalars['numeric']>;
  /** Brix reading of colostrum fed in first feeding */
  colostrum_first_fdg_brix_reading?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for first feeding */
  colostrum_max_first_fdg?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for second feeding */
  colostrum_max_second_fdg?: Maybe<Scalars['numeric']>;
  /** Brix reading of colostrum fed in second feeding */
  colostrum_second_fdg_brix_reading?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  farm_id?: Maybe<Scalars['uuid']>;
  /** This is the calf id entered by the user */
  id?: Maybe<Scalars['String']>;
  /** This is the auto-generated system id. */
  system_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Calf_Min_Fields = {
  __typename?: 'calf_min_fields';
  birth_body_wt?: Maybe<Scalars['numeric']>;
  /** Brix reading of colostrum fed in first feeding */
  colostrum_first_fdg_brix_reading?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for first feeding */
  colostrum_max_first_fdg?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for second feeding */
  colostrum_max_second_fdg?: Maybe<Scalars['numeric']>;
  /** Brix reading of colostrum fed in second feeding */
  colostrum_second_fdg_brix_reading?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  farm_id?: Maybe<Scalars['uuid']>;
  /** This is the calf id entered by the user */
  id?: Maybe<Scalars['String']>;
  /** This is the auto-generated system id. */
  system_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "calf" */
export type Calf_Mutation_Response = {
  __typename?: 'calf_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Calf>;
};

/** on_conflict condition type for table "calf" */
export type Calf_On_Conflict = {
  constraint: Calf_Constraint;
  update_columns?: Array<Calf_Update_Column>;
  where?: Maybe<Calf_Bool_Exp>;
};

/** Ordering options when selecting data from "calf". */
export type Calf_Order_By = {
  birth_body_wt?: Maybe<Order_By>;
  col_rep_measurement_system_id?: Maybe<Order_By>;
  colostrum_first_fdg_brix_reading?: Maybe<Order_By>;
  colostrum_max_first_fdg?: Maybe<Order_By>;
  colostrum_max_second_fdg?: Maybe<Order_By>;
  colostrum_second_fdg_brix_reading?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  farm?: Maybe<Farm_Order_By>;
  farm_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  system_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: calf */
export type Calf_Pk_Columns_Input = {
  /** This is the auto-generated system id. */
  system_id: Scalars['uuid'];
};

/** select columns of table "calf" */
export enum Calf_Select_Column {
  /** column name */
  BirthBodyWt = 'birth_body_wt',
  /** column name */
  ColRepMeasurementSystemId = 'col_rep_measurement_system_id',
  /** column name */
  ColostrumFirstFdgBrixReading = 'colostrum_first_fdg_brix_reading',
  /** column name */
  ColostrumMaxFirstFdg = 'colostrum_max_first_fdg',
  /** column name */
  ColostrumMaxSecondFdg = 'colostrum_max_second_fdg',
  /** column name */
  ColostrumSecondFdgBrixReading = 'colostrum_second_fdg_brix_reading',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmId = 'farm_id',
  /** column name */
  Id = 'id',
  /** column name */
  SystemId = 'system_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "calf" */
export type Calf_Set_Input = {
  birth_body_wt?: Maybe<Scalars['numeric']>;
  col_rep_measurement_system_id?: Maybe<Enum_Measurement_System_Enum>;
  /** Brix reading of colostrum fed in first feeding */
  colostrum_first_fdg_brix_reading?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for first feeding */
  colostrum_max_first_fdg?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for second feeding */
  colostrum_max_second_fdg?: Maybe<Scalars['numeric']>;
  /** Brix reading of colostrum fed in second feeding */
  colostrum_second_fdg_brix_reading?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  farm_id?: Maybe<Scalars['uuid']>;
  /** This is the calf id entered by the user */
  id?: Maybe<Scalars['String']>;
  /** This is the auto-generated system id. */
  system_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Calf_Stddev_Fields = {
  __typename?: 'calf_stddev_fields';
  birth_body_wt?: Maybe<Scalars['Float']>;
  /** Brix reading of colostrum fed in first feeding */
  colostrum_first_fdg_brix_reading?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for first feeding */
  colostrum_max_first_fdg?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for second feeding */
  colostrum_max_second_fdg?: Maybe<Scalars['Float']>;
  /** Brix reading of colostrum fed in second feeding */
  colostrum_second_fdg_brix_reading?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Calf_Stddev_Pop_Fields = {
  __typename?: 'calf_stddev_pop_fields';
  birth_body_wt?: Maybe<Scalars['Float']>;
  /** Brix reading of colostrum fed in first feeding */
  colostrum_first_fdg_brix_reading?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for first feeding */
  colostrum_max_first_fdg?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for second feeding */
  colostrum_max_second_fdg?: Maybe<Scalars['Float']>;
  /** Brix reading of colostrum fed in second feeding */
  colostrum_second_fdg_brix_reading?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Calf_Stddev_Samp_Fields = {
  __typename?: 'calf_stddev_samp_fields';
  birth_body_wt?: Maybe<Scalars['Float']>;
  /** Brix reading of colostrum fed in first feeding */
  colostrum_first_fdg_brix_reading?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for first feeding */
  colostrum_max_first_fdg?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for second feeding */
  colostrum_max_second_fdg?: Maybe<Scalars['Float']>;
  /** Brix reading of colostrum fed in second feeding */
  colostrum_second_fdg_brix_reading?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "calf" */
export type Calf_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Calf_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Calf_Stream_Cursor_Value_Input = {
  birth_body_wt?: Maybe<Scalars['numeric']>;
  col_rep_measurement_system_id?: Maybe<Enum_Measurement_System_Enum>;
  /** Brix reading of colostrum fed in first feeding */
  colostrum_first_fdg_brix_reading?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for first feeding */
  colostrum_max_first_fdg?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for second feeding */
  colostrum_max_second_fdg?: Maybe<Scalars['numeric']>;
  /** Brix reading of colostrum fed in second feeding */
  colostrum_second_fdg_brix_reading?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  farm_id?: Maybe<Scalars['uuid']>;
  /** This is the calf id entered by the user */
  id?: Maybe<Scalars['String']>;
  /** This is the auto-generated system id. */
  system_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Calf_Sum_Fields = {
  __typename?: 'calf_sum_fields';
  birth_body_wt?: Maybe<Scalars['numeric']>;
  /** Brix reading of colostrum fed in first feeding */
  colostrum_first_fdg_brix_reading?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for first feeding */
  colostrum_max_first_fdg?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for second feeding */
  colostrum_max_second_fdg?: Maybe<Scalars['numeric']>;
  /** Brix reading of colostrum fed in second feeding */
  colostrum_second_fdg_brix_reading?: Maybe<Scalars['numeric']>;
};

/** update columns of table "calf" */
export enum Calf_Update_Column {
  /** column name */
  BirthBodyWt = 'birth_body_wt',
  /** column name */
  ColRepMeasurementSystemId = 'col_rep_measurement_system_id',
  /** column name */
  ColostrumFirstFdgBrixReading = 'colostrum_first_fdg_brix_reading',
  /** column name */
  ColostrumMaxFirstFdg = 'colostrum_max_first_fdg',
  /** column name */
  ColostrumMaxSecondFdg = 'colostrum_max_second_fdg',
  /** column name */
  ColostrumSecondFdgBrixReading = 'colostrum_second_fdg_brix_reading',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FarmId = 'farm_id',
  /** column name */
  Id = 'id',
  /** column name */
  SystemId = 'system_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Calf_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Calf_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Calf_Set_Input>;
  /** filter the rows which have to be updated */
  where: Calf_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Calf_Var_Pop_Fields = {
  __typename?: 'calf_var_pop_fields';
  birth_body_wt?: Maybe<Scalars['Float']>;
  /** Brix reading of colostrum fed in first feeding */
  colostrum_first_fdg_brix_reading?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for first feeding */
  colostrum_max_first_fdg?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for second feeding */
  colostrum_max_second_fdg?: Maybe<Scalars['Float']>;
  /** Brix reading of colostrum fed in second feeding */
  colostrum_second_fdg_brix_reading?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Calf_Var_Samp_Fields = {
  __typename?: 'calf_var_samp_fields';
  birth_body_wt?: Maybe<Scalars['Float']>;
  /** Brix reading of colostrum fed in first feeding */
  colostrum_first_fdg_brix_reading?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for first feeding */
  colostrum_max_first_fdg?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for second feeding */
  colostrum_max_second_fdg?: Maybe<Scalars['Float']>;
  /** Brix reading of colostrum fed in second feeding */
  colostrum_second_fdg_brix_reading?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Calf_Variance_Fields = {
  __typename?: 'calf_variance_fields';
  birth_body_wt?: Maybe<Scalars['Float']>;
  /** Brix reading of colostrum fed in first feeding */
  colostrum_first_fdg_brix_reading?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for first feeding */
  colostrum_max_first_fdg?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for second feeding */
  colostrum_max_second_fdg?: Maybe<Scalars['Float']>;
  /** Brix reading of colostrum fed in second feeding */
  colostrum_second_fdg_brix_reading?: Maybe<Scalars['Float']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "enum_calculator" */
export type Enum_Calculator = {
  __typename?: 'enum_calculator';
  display_name?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "enum_calculator" */
export type Enum_Calculator_Aggregate = {
  __typename?: 'enum_calculator_aggregate';
  aggregate?: Maybe<Enum_Calculator_Aggregate_Fields>;
  nodes: Array<Enum_Calculator>;
};

/** aggregate fields of "enum_calculator" */
export type Enum_Calculator_Aggregate_Fields = {
  __typename?: 'enum_calculator_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Enum_Calculator_Max_Fields>;
  min?: Maybe<Enum_Calculator_Min_Fields>;
};


/** aggregate fields of "enum_calculator" */
export type Enum_Calculator_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Enum_Calculator_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_calculator". All fields are combined with a logical 'AND'. */
export type Enum_Calculator_Bool_Exp = {
  _and?: Maybe<Array<Enum_Calculator_Bool_Exp>>;
  _not?: Maybe<Enum_Calculator_Bool_Exp>;
  _or?: Maybe<Array<Enum_Calculator_Bool_Exp>>;
  display_name?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_calculator" */
export enum Enum_Calculator_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnumCalculatorPkey = 'enum_calculator_pkey'
}

export enum Enum_Calculator_Enum {
  CmrSetSolids = 'cmr_set_solids',
  /** NULL */
  ColRepPooled = 'col_rep_pooled',
  PmWater = 'pm_water',
  PmrbNoWater = 'pmrb_no_water'
}

/** Boolean expression to compare columns of type "enum_calculator_enum". All fields are combined with logical 'AND'. */
export type Enum_Calculator_Enum_Comparison_Exp = {
  _eq?: Maybe<Enum_Calculator_Enum>;
  _in?: Maybe<Array<Enum_Calculator_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Enum_Calculator_Enum>;
  _nin?: Maybe<Array<Enum_Calculator_Enum>>;
};

/** input type for inserting data into table "enum_calculator" */
export type Enum_Calculator_Insert_Input = {
  display_name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Enum_Calculator_Max_Fields = {
  __typename?: 'enum_calculator_max_fields';
  display_name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Enum_Calculator_Min_Fields = {
  __typename?: 'enum_calculator_min_fields';
  display_name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_calculator" */
export type Enum_Calculator_Mutation_Response = {
  __typename?: 'enum_calculator_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Calculator>;
};

/** on_conflict condition type for table "enum_calculator" */
export type Enum_Calculator_On_Conflict = {
  constraint: Enum_Calculator_Constraint;
  update_columns?: Array<Enum_Calculator_Update_Column>;
  where?: Maybe<Enum_Calculator_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_calculator". */
export type Enum_Calculator_Order_By = {
  display_name?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: enum_calculator */
export type Enum_Calculator_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "enum_calculator" */
export enum Enum_Calculator_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enum_calculator" */
export type Enum_Calculator_Set_Input = {
  display_name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "enum_calculator" */
export type Enum_Calculator_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Calculator_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Calculator_Stream_Cursor_Value_Input = {
  display_name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "enum_calculator" */
export enum Enum_Calculator_Update_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Value = 'value'
}

export type Enum_Calculator_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Enum_Calculator_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Calculator_Bool_Exp;
};

/** columns and relationships of "enum_measurement_system" */
export type Enum_Measurement_System = {
  __typename?: 'enum_measurement_system';
  display_name?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

/** aggregated selection of "enum_measurement_system" */
export type Enum_Measurement_System_Aggregate = {
  __typename?: 'enum_measurement_system_aggregate';
  aggregate?: Maybe<Enum_Measurement_System_Aggregate_Fields>;
  nodes: Array<Enum_Measurement_System>;
};

/** aggregate fields of "enum_measurement_system" */
export type Enum_Measurement_System_Aggregate_Fields = {
  __typename?: 'enum_measurement_system_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Enum_Measurement_System_Max_Fields>;
  min?: Maybe<Enum_Measurement_System_Min_Fields>;
};


/** aggregate fields of "enum_measurement_system" */
export type Enum_Measurement_System_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Enum_Measurement_System_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_measurement_system". All fields are combined with a logical 'AND'. */
export type Enum_Measurement_System_Bool_Exp = {
  _and?: Maybe<Array<Enum_Measurement_System_Bool_Exp>>;
  _not?: Maybe<Enum_Measurement_System_Bool_Exp>;
  _or?: Maybe<Array<Enum_Measurement_System_Bool_Exp>>;
  display_name?: Maybe<String_Comparison_Exp>;
  id?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_measurement_system" */
export enum Enum_Measurement_System_Constraint {
  /** unique or primary key constraint on columns "id" */
  EnumMeasurementSystemPkey = 'enum_measurement_system_pkey'
}

export enum Enum_Measurement_System_Enum {
  /** Metric */
  Metric = 'metric',
  /** English */
  UsCustomary = 'us_customary'
}

/** Boolean expression to compare columns of type "enum_measurement_system_enum". All fields are combined with logical 'AND'. */
export type Enum_Measurement_System_Enum_Comparison_Exp = {
  _eq?: Maybe<Enum_Measurement_System_Enum>;
  _in?: Maybe<Array<Enum_Measurement_System_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Enum_Measurement_System_Enum>;
  _nin?: Maybe<Array<Enum_Measurement_System_Enum>>;
};

/** input type for inserting data into table "enum_measurement_system" */
export type Enum_Measurement_System_Insert_Input = {
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Enum_Measurement_System_Max_Fields = {
  __typename?: 'enum_measurement_system_max_fields';
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Enum_Measurement_System_Min_Fields = {
  __typename?: 'enum_measurement_system_min_fields';
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_measurement_system" */
export type Enum_Measurement_System_Mutation_Response = {
  __typename?: 'enum_measurement_system_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Measurement_System>;
};

/** on_conflict condition type for table "enum_measurement_system" */
export type Enum_Measurement_System_On_Conflict = {
  constraint: Enum_Measurement_System_Constraint;
  update_columns?: Array<Enum_Measurement_System_Update_Column>;
  where?: Maybe<Enum_Measurement_System_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_measurement_system". */
export type Enum_Measurement_System_Order_By = {
  display_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** primary key columns input for table: enum_measurement_system */
export type Enum_Measurement_System_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "enum_measurement_system" */
export enum Enum_Measurement_System_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "enum_measurement_system" */
export type Enum_Measurement_System_Set_Input = {
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "enum_measurement_system" */
export type Enum_Measurement_System_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Measurement_System_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Measurement_System_Stream_Cursor_Value_Input = {
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** update columns of table "enum_measurement_system" */
export enum Enum_Measurement_System_Update_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id'
}

export type Enum_Measurement_System_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Enum_Measurement_System_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Measurement_System_Bool_Exp;
};

/** ENUM table for user's role */
export type Enum_User_Role = {
  __typename?: 'enum_user_role';
  display_name?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "enum_user_role" */
export type Enum_User_Role_Aggregate = {
  __typename?: 'enum_user_role_aggregate';
  aggregate?: Maybe<Enum_User_Role_Aggregate_Fields>;
  nodes: Array<Enum_User_Role>;
};

/** aggregate fields of "enum_user_role" */
export type Enum_User_Role_Aggregate_Fields = {
  __typename?: 'enum_user_role_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Enum_User_Role_Max_Fields>;
  min?: Maybe<Enum_User_Role_Min_Fields>;
};


/** aggregate fields of "enum_user_role" */
export type Enum_User_Role_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Enum_User_Role_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_user_role". All fields are combined with a logical 'AND'. */
export type Enum_User_Role_Bool_Exp = {
  _and?: Maybe<Array<Enum_User_Role_Bool_Exp>>;
  _not?: Maybe<Enum_User_Role_Bool_Exp>;
  _or?: Maybe<Array<Enum_User_Role_Bool_Exp>>;
  display_name?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_user_role" */
export enum Enum_User_Role_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnumUserRolePkey = 'enum_user_role_pkey'
}

export enum Enum_User_Role_Enum {
  AppAdmin = 'app_admin',
  User = 'user'
}

/** Boolean expression to compare columns of type "enum_user_role_enum". All fields are combined with logical 'AND'. */
export type Enum_User_Role_Enum_Comparison_Exp = {
  _eq?: Maybe<Enum_User_Role_Enum>;
  _in?: Maybe<Array<Enum_User_Role_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Enum_User_Role_Enum>;
  _nin?: Maybe<Array<Enum_User_Role_Enum>>;
};

/** input type for inserting data into table "enum_user_role" */
export type Enum_User_Role_Insert_Input = {
  display_name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Enum_User_Role_Max_Fields = {
  __typename?: 'enum_user_role_max_fields';
  display_name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Enum_User_Role_Min_Fields = {
  __typename?: 'enum_user_role_min_fields';
  display_name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_user_role" */
export type Enum_User_Role_Mutation_Response = {
  __typename?: 'enum_user_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_User_Role>;
};

/** input type for inserting object relation for remote table "enum_user_role" */
export type Enum_User_Role_Obj_Rel_Insert_Input = {
  data: Enum_User_Role_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Enum_User_Role_On_Conflict>;
};

/** on_conflict condition type for table "enum_user_role" */
export type Enum_User_Role_On_Conflict = {
  constraint: Enum_User_Role_Constraint;
  update_columns?: Array<Enum_User_Role_Update_Column>;
  where?: Maybe<Enum_User_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_user_role". */
export type Enum_User_Role_Order_By = {
  display_name?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: enum_user_role */
export type Enum_User_Role_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "enum_user_role" */
export enum Enum_User_Role_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enum_user_role" */
export type Enum_User_Role_Set_Input = {
  display_name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "enum_user_role" */
export type Enum_User_Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_User_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_User_Role_Stream_Cursor_Value_Input = {
  display_name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "enum_user_role" */
export enum Enum_User_Role_Update_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Value = 'value'
}

export type Enum_User_Role_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Enum_User_Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_User_Role_Bool_Exp;
};

/** Table to store farm data */
export type Farm = {
  __typename?: 'farm';
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  /** An array relationship */
  calculations: Array<Calculation>;
  /** An aggregate relationship */
  calculations_aggregate: Calculation_Aggregate;
  /** For calf milk ration module */
  calves_count?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  /** If the value is true, then the user is going to use the pooled calculator. If the value is false, then the user is going to use the 'By calf' calculator. If the value is null, then the user is not using the Colostrum Replacer app */
  col_rep_is_pooling?: Maybe<Scalars['Boolean']>;
  /** For colostrum replacer calculator */
  col_rep_measurement_system_id?: Maybe<Enum_Measurement_System_Enum>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<User>;
  created_by_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  manager_email?: Maybe<Scalars['String']>;
  manager_name?: Maybe<Scalars['String']>;
  manager_phone?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by?: Maybe<User>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  zipcode: Scalars['String'];
};


/** Table to store farm data */
export type FarmCalculationsArgs = {
  distinct_on?: Maybe<Array<Calculation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Calculation_Order_By>>;
  where?: Maybe<Calculation_Bool_Exp>;
};


/** Table to store farm data */
export type FarmCalculations_AggregateArgs = {
  distinct_on?: Maybe<Array<Calculation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Calculation_Order_By>>;
  where?: Maybe<Calculation_Bool_Exp>;
};

/** aggregated selection of "farm" */
export type Farm_Aggregate = {
  __typename?: 'farm_aggregate';
  aggregate?: Maybe<Farm_Aggregate_Fields>;
  nodes: Array<Farm>;
};

export type Farm_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Farm_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Farm_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Farm_Aggregate_Bool_Exp_Count>;
};

export type Farm_Aggregate_Bool_Exp_Bool_And = {
  arguments: Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Farm_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Farm_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Farm_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Farm_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Farm_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Farm_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "farm" */
export type Farm_Aggregate_Fields = {
  __typename?: 'farm_aggregate_fields';
  avg?: Maybe<Farm_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Farm_Max_Fields>;
  min?: Maybe<Farm_Min_Fields>;
  stddev?: Maybe<Farm_Stddev_Fields>;
  stddev_pop?: Maybe<Farm_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farm_Stddev_Samp_Fields>;
  sum?: Maybe<Farm_Sum_Fields>;
  var_pop?: Maybe<Farm_Var_Pop_Fields>;
  var_samp?: Maybe<Farm_Var_Samp_Fields>;
  variance?: Maybe<Farm_Variance_Fields>;
};


/** aggregate fields of "farm" */
export type Farm_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Farm_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "farm" */
export type Farm_Aggregate_Order_By = {
  avg?: Maybe<Farm_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Farm_Max_Order_By>;
  min?: Maybe<Farm_Min_Order_By>;
  stddev?: Maybe<Farm_Stddev_Order_By>;
  stddev_pop?: Maybe<Farm_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Farm_Stddev_Samp_Order_By>;
  sum?: Maybe<Farm_Sum_Order_By>;
  var_pop?: Maybe<Farm_Var_Pop_Order_By>;
  var_samp?: Maybe<Farm_Var_Samp_Order_By>;
  variance?: Maybe<Farm_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "farm" */
export type Farm_Arr_Rel_Insert_Input = {
  data: Array<Farm_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Farm_On_Conflict>;
};

/** aggregate avg on columns */
export type Farm_Avg_Fields = {
  __typename?: 'farm_avg_fields';
  /** For calf milk ration module */
  calves_count?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Scalars['Float']>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "farm" */
export type Farm_Avg_Order_By = {
  /** For calf milk ration module */
  calves_count?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Order_By>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "farm". All fields are combined with a logical 'AND'. */
export type Farm_Bool_Exp = {
  _and?: Maybe<Array<Farm_Bool_Exp>>;
  _not?: Maybe<Farm_Bool_Exp>;
  _or?: Maybe<Array<Farm_Bool_Exp>>;
  address_line_1?: Maybe<String_Comparison_Exp>;
  address_line_2?: Maybe<String_Comparison_Exp>;
  calculations?: Maybe<Calculation_Bool_Exp>;
  calculations_aggregate?: Maybe<Calculation_Aggregate_Bool_Exp>;
  calves_count?: Maybe<Int_Comparison_Exp>;
  city?: Maybe<String_Comparison_Exp>;
  col_rep_is_pooling?: Maybe<Boolean_Comparison_Exp>;
  col_rep_measurement_system_id?: Maybe<Enum_Measurement_System_Enum_Comparison_Exp>;
  colostrum_max_first_fdg?: Maybe<Numeric_Comparison_Exp>;
  colostrum_max_second_fdg?: Maybe<Numeric_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<User_Bool_Exp>;
  created_by_id?: Maybe<Uuid_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  feedings_per_day?: Maybe<Numeric_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  manager_email?: Maybe<String_Comparison_Exp>;
  manager_name?: Maybe<String_Comparison_Exp>;
  manager_phone?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  state?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_by?: Maybe<User_Bool_Exp>;
  updated_by_id?: Maybe<Uuid_Comparison_Exp>;
  zipcode?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "farm" */
export enum Farm_Constraint {
  /** unique or primary key constraint on columns "id" */
  FarmPkey = 'farm_pkey'
}

/** input type for incrementing numeric columns in table "farm" */
export type Farm_Inc_Input = {
  /** For calf milk ration module */
  calves_count?: Maybe<Scalars['Int']>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Scalars['numeric']>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "farm" */
export type Farm_Insert_Input = {
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  calculations?: Maybe<Calculation_Arr_Rel_Insert_Input>;
  /** For calf milk ration module */
  calves_count?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  /** If the value is true, then the user is going to use the pooled calculator. If the value is false, then the user is going to use the 'By calf' calculator. If the value is null, then the user is not using the Colostrum Replacer app */
  col_rep_is_pooling?: Maybe<Scalars['Boolean']>;
  /** For colostrum replacer calculator */
  col_rep_measurement_system_id?: Maybe<Enum_Measurement_System_Enum>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<User_Obj_Rel_Insert_Input>;
  created_by_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  manager_email?: Maybe<Scalars['String']>;
  manager_name?: Maybe<Scalars['String']>;
  manager_phone?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<User_Obj_Rel_Insert_Input>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Farm_Max_Fields = {
  __typename?: 'farm_max_fields';
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  /** For calf milk ration module */
  calves_count?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  manager_email?: Maybe<Scalars['String']>;
  manager_name?: Maybe<Scalars['String']>;
  manager_phone?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "farm" */
export type Farm_Max_Order_By = {
  address_line_1?: Maybe<Order_By>;
  address_line_2?: Maybe<Order_By>;
  /** For calf milk ration module */
  calves_count?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manager_email?: Maybe<Order_By>;
  manager_name?: Maybe<Order_By>;
  manager_phone?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by_id?: Maybe<Order_By>;
  zipcode?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Farm_Min_Fields = {
  __typename?: 'farm_min_fields';
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  /** For calf milk ration module */
  calves_count?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  manager_email?: Maybe<Scalars['String']>;
  manager_name?: Maybe<Scalars['String']>;
  manager_phone?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "farm" */
export type Farm_Min_Order_By = {
  address_line_1?: Maybe<Order_By>;
  address_line_2?: Maybe<Order_By>;
  /** For calf milk ration module */
  calves_count?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manager_email?: Maybe<Order_By>;
  manager_name?: Maybe<Order_By>;
  manager_phone?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by_id?: Maybe<Order_By>;
  zipcode?: Maybe<Order_By>;
};

/** response of any mutation on the table "farm" */
export type Farm_Mutation_Response = {
  __typename?: 'farm_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Farm>;
};

/** input type for inserting object relation for remote table "farm" */
export type Farm_Obj_Rel_Insert_Input = {
  data: Farm_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Farm_On_Conflict>;
};

/** on_conflict condition type for table "farm" */
export type Farm_On_Conflict = {
  constraint: Farm_Constraint;
  update_columns?: Array<Farm_Update_Column>;
  where?: Maybe<Farm_Bool_Exp>;
};

/** Ordering options when selecting data from "farm". */
export type Farm_Order_By = {
  address_line_1?: Maybe<Order_By>;
  address_line_2?: Maybe<Order_By>;
  calculations_aggregate?: Maybe<Calculation_Aggregate_Order_By>;
  calves_count?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  col_rep_is_pooling?: Maybe<Order_By>;
  col_rep_measurement_system_id?: Maybe<Order_By>;
  colostrum_max_first_fdg?: Maybe<Order_By>;
  colostrum_max_second_fdg?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<User_Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  feedings_per_day?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manager_email?: Maybe<Order_By>;
  manager_name?: Maybe<Order_By>;
  manager_phone?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<User_Order_By>;
  updated_by_id?: Maybe<Order_By>;
  zipcode?: Maybe<Order_By>;
};

/** primary key columns input for table: farm */
export type Farm_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "farm" */
export enum Farm_Select_Column {
  /** column name */
  AddressLine_1 = 'address_line_1',
  /** column name */
  AddressLine_2 = 'address_line_2',
  /** column name */
  CalvesCount = 'calves_count',
  /** column name */
  City = 'city',
  /** column name */
  ColRepIsPooling = 'col_rep_is_pooling',
  /** column name */
  ColRepMeasurementSystemId = 'col_rep_measurement_system_id',
  /** column name */
  ColostrumMaxFirstFdg = 'colostrum_max_first_fdg',
  /** column name */
  ColostrumMaxSecondFdg = 'colostrum_max_second_fdg',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FeedingsPerDay = 'feedings_per_day',
  /** column name */
  Id = 'id',
  /** column name */
  ManagerEmail = 'manager_email',
  /** column name */
  ManagerName = 'manager_name',
  /** column name */
  ManagerPhone = 'manager_phone',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Zipcode = 'zipcode'
}

/** select "farm_aggregate_bool_exp_bool_and_arguments_columns" columns of table "farm" */
export enum Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ColRepIsPooling = 'col_rep_is_pooling'
}

/** select "farm_aggregate_bool_exp_bool_or_arguments_columns" columns of table "farm" */
export enum Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ColRepIsPooling = 'col_rep_is_pooling'
}

/** input type for updating data in table "farm" */
export type Farm_Set_Input = {
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  /** For calf milk ration module */
  calves_count?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  /** If the value is true, then the user is going to use the pooled calculator. If the value is false, then the user is going to use the 'By calf' calculator. If the value is null, then the user is not using the Colostrum Replacer app */
  col_rep_is_pooling?: Maybe<Scalars['Boolean']>;
  /** For colostrum replacer calculator */
  col_rep_measurement_system_id?: Maybe<Enum_Measurement_System_Enum>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  manager_email?: Maybe<Scalars['String']>;
  manager_name?: Maybe<Scalars['String']>;
  manager_phone?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Farm_Stddev_Fields = {
  __typename?: 'farm_stddev_fields';
  /** For calf milk ration module */
  calves_count?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Scalars['Float']>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "farm" */
export type Farm_Stddev_Order_By = {
  /** For calf milk ration module */
  calves_count?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Order_By>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Farm_Stddev_Pop_Fields = {
  __typename?: 'farm_stddev_pop_fields';
  /** For calf milk ration module */
  calves_count?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Scalars['Float']>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "farm" */
export type Farm_Stddev_Pop_Order_By = {
  /** For calf milk ration module */
  calves_count?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Order_By>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Farm_Stddev_Samp_Fields = {
  __typename?: 'farm_stddev_samp_fields';
  /** For calf milk ration module */
  calves_count?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Scalars['Float']>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "farm" */
export type Farm_Stddev_Samp_Order_By = {
  /** For calf milk ration module */
  calves_count?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Order_By>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Order_By>;
};

/** Streaming cursor of the table "farm" */
export type Farm_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farm_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farm_Stream_Cursor_Value_Input = {
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  /** For calf milk ration module */
  calves_count?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  /** If the value is true, then the user is going to use the pooled calculator. If the value is false, then the user is going to use the 'By calf' calculator. If the value is null, then the user is not using the Colostrum Replacer app */
  col_rep_is_pooling?: Maybe<Scalars['Boolean']>;
  /** For colostrum replacer calculator */
  col_rep_measurement_system_id?: Maybe<Enum_Measurement_System_Enum>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  manager_email?: Maybe<Scalars['String']>;
  manager_name?: Maybe<Scalars['String']>;
  manager_phone?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Farm_Sum_Fields = {
  __typename?: 'farm_sum_fields';
  /** For calf milk ration module */
  calves_count?: Maybe<Scalars['Int']>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Scalars['numeric']>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Scalars['numeric']>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "farm" */
export type Farm_Sum_Order_By = {
  /** For calf milk ration module */
  calves_count?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Order_By>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Order_By>;
};

/** update columns of table "farm" */
export enum Farm_Update_Column {
  /** column name */
  AddressLine_1 = 'address_line_1',
  /** column name */
  AddressLine_2 = 'address_line_2',
  /** column name */
  CalvesCount = 'calves_count',
  /** column name */
  City = 'city',
  /** column name */
  ColRepIsPooling = 'col_rep_is_pooling',
  /** column name */
  ColRepMeasurementSystemId = 'col_rep_measurement_system_id',
  /** column name */
  ColostrumMaxFirstFdg = 'colostrum_max_first_fdg',
  /** column name */
  ColostrumMaxSecondFdg = 'colostrum_max_second_fdg',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FeedingsPerDay = 'feedings_per_day',
  /** column name */
  Id = 'id',
  /** column name */
  ManagerEmail = 'manager_email',
  /** column name */
  ManagerName = 'manager_name',
  /** column name */
  ManagerPhone = 'manager_phone',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Zipcode = 'zipcode'
}

export type Farm_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Farm_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Farm_Set_Input>;
  /** filter the rows which have to be updated */
  where: Farm_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Farm_Var_Pop_Fields = {
  __typename?: 'farm_var_pop_fields';
  /** For calf milk ration module */
  calves_count?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Scalars['Float']>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "farm" */
export type Farm_Var_Pop_Order_By = {
  /** For calf milk ration module */
  calves_count?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Order_By>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Farm_Var_Samp_Fields = {
  __typename?: 'farm_var_samp_fields';
  /** For calf milk ration module */
  calves_count?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Scalars['Float']>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "farm" */
export type Farm_Var_Samp_Order_By = {
  /** For calf milk ration module */
  calves_count?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Order_By>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Farm_Variance_Fields = {
  __typename?: 'farm_variance_fields';
  /** For calf milk ration module */
  calves_count?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Scalars['Float']>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Scalars['Float']>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "farm" */
export type Farm_Variance_Order_By = {
  /** For calf milk ration module */
  calves_count?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for first feeding for colostrum replacer calculator */
  colostrum_max_first_fdg?: Maybe<Order_By>;
  /** Desired Max volume of colostrum for second feeding for colostrum replacer calculator */
  colostrum_max_second_fdg?: Maybe<Order_By>;
  /** For calf milk ration module */
  feedings_per_day?: Maybe<Order_By>;
};


export type Jsonb_Cast_Exp = {
  String?: Maybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: Maybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: Maybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: Maybe<Scalars['jsonb']>;
  _eq?: Maybe<Scalars['jsonb']>;
  _gt?: Maybe<Scalars['jsonb']>;
  _gte?: Maybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: Maybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: Maybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: Maybe<Array<Scalars['String']>>;
  _in?: Maybe<Array<Scalars['jsonb']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['jsonb']>;
  _lte?: Maybe<Scalars['jsonb']>;
  _neq?: Maybe<Scalars['jsonb']>;
  _nin?: Maybe<Array<Scalars['jsonb']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  deleteAccount?: Maybe<DeleteAccountOutput>;
  /** delete data from the table: "calculation" */
  delete_calculation?: Maybe<Calculation_Mutation_Response>;
  /** delete single row from the table: "calculation" */
  delete_calculation_by_pk?: Maybe<Calculation>;
  /** delete data from the table: "calf" */
  delete_calf?: Maybe<Calf_Mutation_Response>;
  /** delete single row from the table: "calf" */
  delete_calf_by_pk?: Maybe<Calf>;
  /** delete data from the table: "enum_calculator" */
  delete_enum_calculator?: Maybe<Enum_Calculator_Mutation_Response>;
  /** delete single row from the table: "enum_calculator" */
  delete_enum_calculator_by_pk?: Maybe<Enum_Calculator>;
  /** delete data from the table: "enum_measurement_system" */
  delete_enum_measurement_system?: Maybe<Enum_Measurement_System_Mutation_Response>;
  /** delete single row from the table: "enum_measurement_system" */
  delete_enum_measurement_system_by_pk?: Maybe<Enum_Measurement_System>;
  /** delete data from the table: "enum_user_role" */
  delete_enum_user_role?: Maybe<Enum_User_Role_Mutation_Response>;
  /** delete single row from the table: "enum_user_role" */
  delete_enum_user_role_by_pk?: Maybe<Enum_User_Role>;
  /** delete data from the table: "farm" */
  delete_farm?: Maybe<Farm_Mutation_Response>;
  /** delete single row from the table: "farm" */
  delete_farm_by_pk?: Maybe<Farm>;
  /** delete data from the table: "report" */
  delete_report?: Maybe<Report_Mutation_Response>;
  /** delete single row from the table: "report" */
  delete_report_by_pk?: Maybe<Report>;
  /** delete data from the table: "user" */
  delete_user?: Maybe<User_Mutation_Response>;
  /** delete single row from the table: "user" */
  delete_user_by_pk?: Maybe<User>;
  generateColostrumReplacerReport?: Maybe<GenerateReportOutput>;
  generateReport?: Maybe<GenerateReportOutput>;
  /** insert data into the table: "calculation" */
  insert_calculation?: Maybe<Calculation_Mutation_Response>;
  /** insert a single row into the table: "calculation" */
  insert_calculation_one?: Maybe<Calculation>;
  /** insert data into the table: "calf" */
  insert_calf?: Maybe<Calf_Mutation_Response>;
  /** insert a single row into the table: "calf" */
  insert_calf_one?: Maybe<Calf>;
  /** insert data into the table: "enum_calculator" */
  insert_enum_calculator?: Maybe<Enum_Calculator_Mutation_Response>;
  /** insert a single row into the table: "enum_calculator" */
  insert_enum_calculator_one?: Maybe<Enum_Calculator>;
  /** insert data into the table: "enum_measurement_system" */
  insert_enum_measurement_system?: Maybe<Enum_Measurement_System_Mutation_Response>;
  /** insert a single row into the table: "enum_measurement_system" */
  insert_enum_measurement_system_one?: Maybe<Enum_Measurement_System>;
  /** insert data into the table: "enum_user_role" */
  insert_enum_user_role?: Maybe<Enum_User_Role_Mutation_Response>;
  /** insert a single row into the table: "enum_user_role" */
  insert_enum_user_role_one?: Maybe<Enum_User_Role>;
  /** insert data into the table: "farm" */
  insert_farm?: Maybe<Farm_Mutation_Response>;
  /** insert a single row into the table: "farm" */
  insert_farm_one?: Maybe<Farm>;
  /** insert data into the table: "report" */
  insert_report?: Maybe<Report_Mutation_Response>;
  /** insert a single row into the table: "report" */
  insert_report_one?: Maybe<Report>;
  /** insert data into the table: "user" */
  insert_user?: Maybe<User_Mutation_Response>;
  /** insert a single row into the table: "user" */
  insert_user_one?: Maybe<User>;
  moduleRequestAccess?: Maybe<ModuleRequestAccessOutput>;
  /** update data of the table: "calculation" */
  update_calculation?: Maybe<Calculation_Mutation_Response>;
  /** update single row of the table: "calculation" */
  update_calculation_by_pk?: Maybe<Calculation>;
  /** update multiples rows of table: "calculation" */
  update_calculation_many?: Maybe<Array<Maybe<Calculation_Mutation_Response>>>;
  /** update data of the table: "calf" */
  update_calf?: Maybe<Calf_Mutation_Response>;
  /** update single row of the table: "calf" */
  update_calf_by_pk?: Maybe<Calf>;
  /** update multiples rows of table: "calf" */
  update_calf_many?: Maybe<Array<Maybe<Calf_Mutation_Response>>>;
  /** update data of the table: "enum_calculator" */
  update_enum_calculator?: Maybe<Enum_Calculator_Mutation_Response>;
  /** update single row of the table: "enum_calculator" */
  update_enum_calculator_by_pk?: Maybe<Enum_Calculator>;
  /** update multiples rows of table: "enum_calculator" */
  update_enum_calculator_many?: Maybe<Array<Maybe<Enum_Calculator_Mutation_Response>>>;
  /** update data of the table: "enum_measurement_system" */
  update_enum_measurement_system?: Maybe<Enum_Measurement_System_Mutation_Response>;
  /** update single row of the table: "enum_measurement_system" */
  update_enum_measurement_system_by_pk?: Maybe<Enum_Measurement_System>;
  /** update multiples rows of table: "enum_measurement_system" */
  update_enum_measurement_system_many?: Maybe<Array<Maybe<Enum_Measurement_System_Mutation_Response>>>;
  /** update data of the table: "enum_user_role" */
  update_enum_user_role?: Maybe<Enum_User_Role_Mutation_Response>;
  /** update single row of the table: "enum_user_role" */
  update_enum_user_role_by_pk?: Maybe<Enum_User_Role>;
  /** update multiples rows of table: "enum_user_role" */
  update_enum_user_role_many?: Maybe<Array<Maybe<Enum_User_Role_Mutation_Response>>>;
  /** update data of the table: "farm" */
  update_farm?: Maybe<Farm_Mutation_Response>;
  /** update single row of the table: "farm" */
  update_farm_by_pk?: Maybe<Farm>;
  /** update multiples rows of table: "farm" */
  update_farm_many?: Maybe<Array<Maybe<Farm_Mutation_Response>>>;
  /** update data of the table: "report" */
  update_report?: Maybe<Report_Mutation_Response>;
  /** update single row of the table: "report" */
  update_report_by_pk?: Maybe<Report>;
  /** update multiples rows of table: "report" */
  update_report_many?: Maybe<Array<Maybe<Report_Mutation_Response>>>;
  /** update data of the table: "user" */
  update_user?: Maybe<User_Mutation_Response>;
  /** update single row of the table: "user" */
  update_user_by_pk?: Maybe<User>;
  /** update multiples rows of table: "user" */
  update_user_many?: Maybe<Array<Maybe<User_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_CalculationArgs = {
  where: Calculation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Calculation_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CalfArgs = {
  where: Calf_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Calf_By_PkArgs = {
  system_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_CalculatorArgs = {
  where: Enum_Calculator_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Calculator_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_Measurement_SystemArgs = {
  where: Enum_Measurement_System_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Measurement_System_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_User_RoleArgs = {
  where: Enum_User_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_User_Role_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_FarmArgs = {
  where: Farm_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Farm_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ReportArgs = {
  where: Report_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Report_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_UserArgs = {
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootGenerateColostrumReplacerReportArgs = {
  data: Scalars['String'];
};


/** mutation root */
export type Mutation_RootGenerateReportArgs = {
  data: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInsert_CalculationArgs = {
  objects: Array<Calculation_Insert_Input>;
  on_conflict?: Maybe<Calculation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Calculation_OneArgs = {
  object: Calculation_Insert_Input;
  on_conflict?: Maybe<Calculation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CalfArgs = {
  objects: Array<Calf_Insert_Input>;
  on_conflict?: Maybe<Calf_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Calf_OneArgs = {
  object: Calf_Insert_Input;
  on_conflict?: Maybe<Calf_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_CalculatorArgs = {
  objects: Array<Enum_Calculator_Insert_Input>;
  on_conflict?: Maybe<Enum_Calculator_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Calculator_OneArgs = {
  object: Enum_Calculator_Insert_Input;
  on_conflict?: Maybe<Enum_Calculator_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Measurement_SystemArgs = {
  objects: Array<Enum_Measurement_System_Insert_Input>;
  on_conflict?: Maybe<Enum_Measurement_System_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Measurement_System_OneArgs = {
  object: Enum_Measurement_System_Insert_Input;
  on_conflict?: Maybe<Enum_Measurement_System_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_User_RoleArgs = {
  objects: Array<Enum_User_Role_Insert_Input>;
  on_conflict?: Maybe<Enum_User_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_User_Role_OneArgs = {
  object: Enum_User_Role_Insert_Input;
  on_conflict?: Maybe<Enum_User_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FarmArgs = {
  objects: Array<Farm_Insert_Input>;
  on_conflict?: Maybe<Farm_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farm_OneArgs = {
  object: Farm_Insert_Input;
  on_conflict?: Maybe<Farm_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportArgs = {
  objects: Array<Report_Insert_Input>;
  on_conflict?: Maybe<Report_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Report_OneArgs = {
  object: Report_Insert_Input;
  on_conflict?: Maybe<Report_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserArgs = {
  objects: Array<User_Insert_Input>;
  on_conflict?: Maybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_OneArgs = {
  object: User_Insert_Input;
  on_conflict?: Maybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootModuleRequestAccessArgs = {
  module: ModuleRequestAccessEnum;
};


/** mutation root */
export type Mutation_RootUpdate_CalculationArgs = {
  _append?: Maybe<Calculation_Append_Input>;
  _delete_at_path?: Maybe<Calculation_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Calculation_Delete_Elem_Input>;
  _delete_key?: Maybe<Calculation_Delete_Key_Input>;
  _prepend?: Maybe<Calculation_Prepend_Input>;
  _set?: Maybe<Calculation_Set_Input>;
  where: Calculation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Calculation_By_PkArgs = {
  _append?: Maybe<Calculation_Append_Input>;
  _delete_at_path?: Maybe<Calculation_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Calculation_Delete_Elem_Input>;
  _delete_key?: Maybe<Calculation_Delete_Key_Input>;
  _prepend?: Maybe<Calculation_Prepend_Input>;
  _set?: Maybe<Calculation_Set_Input>;
  pk_columns: Calculation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Calculation_ManyArgs = {
  updates: Array<Calculation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CalfArgs = {
  _inc?: Maybe<Calf_Inc_Input>;
  _set?: Maybe<Calf_Set_Input>;
  where: Calf_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Calf_By_PkArgs = {
  _inc?: Maybe<Calf_Inc_Input>;
  _set?: Maybe<Calf_Set_Input>;
  pk_columns: Calf_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Calf_ManyArgs = {
  updates: Array<Calf_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_CalculatorArgs = {
  _set?: Maybe<Enum_Calculator_Set_Input>;
  where: Enum_Calculator_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Calculator_By_PkArgs = {
  _set?: Maybe<Enum_Calculator_Set_Input>;
  pk_columns: Enum_Calculator_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Calculator_ManyArgs = {
  updates: Array<Enum_Calculator_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Measurement_SystemArgs = {
  _set?: Maybe<Enum_Measurement_System_Set_Input>;
  where: Enum_Measurement_System_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Measurement_System_By_PkArgs = {
  _set?: Maybe<Enum_Measurement_System_Set_Input>;
  pk_columns: Enum_Measurement_System_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Measurement_System_ManyArgs = {
  updates: Array<Enum_Measurement_System_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_User_RoleArgs = {
  _set?: Maybe<Enum_User_Role_Set_Input>;
  where: Enum_User_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_User_Role_By_PkArgs = {
  _set?: Maybe<Enum_User_Role_Set_Input>;
  pk_columns: Enum_User_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_User_Role_ManyArgs = {
  updates: Array<Enum_User_Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FarmArgs = {
  _inc?: Maybe<Farm_Inc_Input>;
  _set?: Maybe<Farm_Set_Input>;
  where: Farm_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Farm_By_PkArgs = {
  _inc?: Maybe<Farm_Inc_Input>;
  _set?: Maybe<Farm_Set_Input>;
  pk_columns: Farm_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Farm_ManyArgs = {
  updates: Array<Farm_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReportArgs = {
  _append?: Maybe<Report_Append_Input>;
  _delete_at_path?: Maybe<Report_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Report_Delete_Elem_Input>;
  _delete_key?: Maybe<Report_Delete_Key_Input>;
  _inc?: Maybe<Report_Inc_Input>;
  _prepend?: Maybe<Report_Prepend_Input>;
  _set?: Maybe<Report_Set_Input>;
  where: Report_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Report_By_PkArgs = {
  _append?: Maybe<Report_Append_Input>;
  _delete_at_path?: Maybe<Report_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Report_Delete_Elem_Input>;
  _delete_key?: Maybe<Report_Delete_Key_Input>;
  _inc?: Maybe<Report_Inc_Input>;
  _prepend?: Maybe<Report_Prepend_Input>;
  _set?: Maybe<Report_Set_Input>;
  pk_columns: Report_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Report_ManyArgs = {
  updates: Array<Report_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserArgs = {
  _set?: Maybe<User_Set_Input>;
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_By_PkArgs = {
  _set?: Maybe<User_Set_Input>;
  pk_columns: User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_ManyArgs = {
  updates: Array<User_Updates>;
};


/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: Maybe<Scalars['numeric']>;
  _gt?: Maybe<Scalars['numeric']>;
  _gte?: Maybe<Scalars['numeric']>;
  _in?: Maybe<Array<Scalars['numeric']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['numeric']>;
  _lte?: Maybe<Scalars['numeric']>;
  _neq?: Maybe<Scalars['numeric']>;
  _nin?: Maybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "calculation" */
  calculation: Array<Calculation>;
  /** fetch aggregated fields from the table: "calculation" */
  calculation_aggregate: Calculation_Aggregate;
  /** fetch data from the table: "calculation" using primary key columns */
  calculation_by_pk?: Maybe<Calculation>;
  /** fetch data from the table: "calf" */
  calf: Array<Calf>;
  /** fetch aggregated fields from the table: "calf" */
  calf_aggregate: Calf_Aggregate;
  /** fetch data from the table: "calf" using primary key columns */
  calf_by_pk?: Maybe<Calf>;
  /** fetch data from the table: "enum_calculator" */
  enum_calculator: Array<Enum_Calculator>;
  /** fetch aggregated fields from the table: "enum_calculator" */
  enum_calculator_aggregate: Enum_Calculator_Aggregate;
  /** fetch data from the table: "enum_calculator" using primary key columns */
  enum_calculator_by_pk?: Maybe<Enum_Calculator>;
  /** fetch data from the table: "enum_measurement_system" */
  enum_measurement_system: Array<Enum_Measurement_System>;
  /** fetch aggregated fields from the table: "enum_measurement_system" */
  enum_measurement_system_aggregate: Enum_Measurement_System_Aggregate;
  /** fetch data from the table: "enum_measurement_system" using primary key columns */
  enum_measurement_system_by_pk?: Maybe<Enum_Measurement_System>;
  /** fetch data from the table: "enum_user_role" */
  enum_user_role: Array<Enum_User_Role>;
  /** fetch aggregated fields from the table: "enum_user_role" */
  enum_user_role_aggregate: Enum_User_Role_Aggregate;
  /** fetch data from the table: "enum_user_role" using primary key columns */
  enum_user_role_by_pk?: Maybe<Enum_User_Role>;
  /** fetch data from the table: "farm" */
  farm: Array<Farm>;
  /** fetch aggregated fields from the table: "farm" */
  farm_aggregate: Farm_Aggregate;
  /** fetch data from the table: "farm" using primary key columns */
  farm_by_pk?: Maybe<Farm>;
  getIgGInColostrumReplacer?: Maybe<GetIgGInColostrumReplacerOutput>;
  /** fetch data from the table: "report" */
  report: Array<Report>;
  /** fetch aggregated fields from the table: "report" */
  report_aggregate: Report_Aggregate;
  /** fetch data from the table: "report" using primary key columns */
  report_by_pk?: Maybe<Report>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
};


export type Query_RootCalculationArgs = {
  distinct_on?: Maybe<Array<Calculation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Calculation_Order_By>>;
  where?: Maybe<Calculation_Bool_Exp>;
};


export type Query_RootCalculation_AggregateArgs = {
  distinct_on?: Maybe<Array<Calculation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Calculation_Order_By>>;
  where?: Maybe<Calculation_Bool_Exp>;
};


export type Query_RootCalculation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCalfArgs = {
  distinct_on?: Maybe<Array<Calf_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Calf_Order_By>>;
  where?: Maybe<Calf_Bool_Exp>;
};


export type Query_RootCalf_AggregateArgs = {
  distinct_on?: Maybe<Array<Calf_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Calf_Order_By>>;
  where?: Maybe<Calf_Bool_Exp>;
};


export type Query_RootCalf_By_PkArgs = {
  system_id: Scalars['uuid'];
};


export type Query_RootEnum_CalculatorArgs = {
  distinct_on?: Maybe<Array<Enum_Calculator_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_Calculator_Order_By>>;
  where?: Maybe<Enum_Calculator_Bool_Exp>;
};


export type Query_RootEnum_Calculator_AggregateArgs = {
  distinct_on?: Maybe<Array<Enum_Calculator_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_Calculator_Order_By>>;
  where?: Maybe<Enum_Calculator_Bool_Exp>;
};


export type Query_RootEnum_Calculator_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootEnum_Measurement_SystemArgs = {
  distinct_on?: Maybe<Array<Enum_Measurement_System_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_Measurement_System_Order_By>>;
  where?: Maybe<Enum_Measurement_System_Bool_Exp>;
};


export type Query_RootEnum_Measurement_System_AggregateArgs = {
  distinct_on?: Maybe<Array<Enum_Measurement_System_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_Measurement_System_Order_By>>;
  where?: Maybe<Enum_Measurement_System_Bool_Exp>;
};


export type Query_RootEnum_Measurement_System_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootEnum_User_RoleArgs = {
  distinct_on?: Maybe<Array<Enum_User_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_User_Role_Order_By>>;
  where?: Maybe<Enum_User_Role_Bool_Exp>;
};


export type Query_RootEnum_User_Role_AggregateArgs = {
  distinct_on?: Maybe<Array<Enum_User_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_User_Role_Order_By>>;
  where?: Maybe<Enum_User_Role_Bool_Exp>;
};


export type Query_RootEnum_User_Role_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootFarmArgs = {
  distinct_on?: Maybe<Array<Farm_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Farm_Order_By>>;
  where?: Maybe<Farm_Bool_Exp>;
};


export type Query_RootFarm_AggregateArgs = {
  distinct_on?: Maybe<Array<Farm_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Farm_Order_By>>;
  where?: Maybe<Farm_Bool_Exp>;
};


export type Query_RootFarm_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootReportArgs = {
  distinct_on?: Maybe<Array<Report_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Report_Order_By>>;
  where?: Maybe<Report_Bool_Exp>;
};


export type Query_RootReport_AggregateArgs = {
  distinct_on?: Maybe<Array<Report_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Report_Order_By>>;
  where?: Maybe<Report_Bool_Exp>;
};


export type Query_RootReport_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUserArgs = {
  distinct_on?: Maybe<Array<User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Order_By>>;
  where?: Maybe<User_Bool_Exp>;
};


export type Query_RootUser_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Order_By>>;
  where?: Maybe<User_Bool_Exp>;
};


export type Query_RootUser_By_PkArgs = {
  id: Scalars['uuid'];
};

/** columns and relationships of "report" */
export type Report = {
  __typename?: 'report';
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['uuid'];
  data: Scalars['jsonb'];
  id: Scalars['Int'];
  s3_key: Scalars['String'];
};


/** columns and relationships of "report" */
export type ReportDataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "report" */
export type Report_Aggregate = {
  __typename?: 'report_aggregate';
  aggregate?: Maybe<Report_Aggregate_Fields>;
  nodes: Array<Report>;
};

/** aggregate fields of "report" */
export type Report_Aggregate_Fields = {
  __typename?: 'report_aggregate_fields';
  avg?: Maybe<Report_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Report_Max_Fields>;
  min?: Maybe<Report_Min_Fields>;
  stddev?: Maybe<Report_Stddev_Fields>;
  stddev_pop?: Maybe<Report_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Report_Stddev_Samp_Fields>;
  sum?: Maybe<Report_Sum_Fields>;
  var_pop?: Maybe<Report_Var_Pop_Fields>;
  var_samp?: Maybe<Report_Var_Samp_Fields>;
  variance?: Maybe<Report_Variance_Fields>;
};


/** aggregate fields of "report" */
export type Report_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Report_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Report_Append_Input = {
  data?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Report_Avg_Fields = {
  __typename?: 'report_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "report". All fields are combined with a logical 'AND'. */
export type Report_Bool_Exp = {
  _and?: Maybe<Array<Report_Bool_Exp>>;
  _not?: Maybe<Report_Bool_Exp>;
  _or?: Maybe<Array<Report_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by_id?: Maybe<Uuid_Comparison_Exp>;
  data?: Maybe<Jsonb_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  s3_key?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "report" */
export enum Report_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReportPkey = 'report_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Report_Delete_At_Path_Input = {
  data?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Report_Delete_Elem_Input = {
  data?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Report_Delete_Key_Input = {
  data?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "report" */
export type Report_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "report" */
export type Report_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  data?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['Int']>;
  s3_key?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Report_Max_Fields = {
  __typename?: 'report_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  s3_key?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Report_Min_Fields = {
  __typename?: 'report_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  s3_key?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "report" */
export type Report_Mutation_Response = {
  __typename?: 'report_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Report>;
};

/** on_conflict condition type for table "report" */
export type Report_On_Conflict = {
  constraint: Report_Constraint;
  update_columns?: Array<Report_Update_Column>;
  where?: Maybe<Report_Bool_Exp>;
};

/** Ordering options when selecting data from "report". */
export type Report_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  data?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  s3_key?: Maybe<Order_By>;
};

/** primary key columns input for table: report */
export type Report_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Report_Prepend_Input = {
  data?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "report" */
export enum Report_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  S3Key = 's3_key'
}

/** input type for updating data in table "report" */
export type Report_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  data?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['Int']>;
  s3_key?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Report_Stddev_Fields = {
  __typename?: 'report_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Report_Stddev_Pop_Fields = {
  __typename?: 'report_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Report_Stddev_Samp_Fields = {
  __typename?: 'report_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "report" */
export type Report_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Report_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Report_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  data?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['Int']>;
  s3_key?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Report_Sum_Fields = {
  __typename?: 'report_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "report" */
export enum Report_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  S3Key = 's3_key'
}

export type Report_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Report_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Report_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Report_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Report_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Report_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Report_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Report_Set_Input>;
  /** filter the rows which have to be updated */
  where: Report_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Report_Var_Pop_Fields = {
  __typename?: 'report_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Report_Var_Samp_Fields = {
  __typename?: 'report_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Report_Variance_Fields = {
  __typename?: 'report_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "calculation" */
  calculation: Array<Calculation>;
  /** fetch aggregated fields from the table: "calculation" */
  calculation_aggregate: Calculation_Aggregate;
  /** fetch data from the table: "calculation" using primary key columns */
  calculation_by_pk?: Maybe<Calculation>;
  /** fetch data from the table in a streaming manner: "calculation" */
  calculation_stream: Array<Calculation>;
  /** fetch data from the table: "calf" */
  calf: Array<Calf>;
  /** fetch aggregated fields from the table: "calf" */
  calf_aggregate: Calf_Aggregate;
  /** fetch data from the table: "calf" using primary key columns */
  calf_by_pk?: Maybe<Calf>;
  /** fetch data from the table in a streaming manner: "calf" */
  calf_stream: Array<Calf>;
  /** fetch data from the table: "enum_calculator" */
  enum_calculator: Array<Enum_Calculator>;
  /** fetch aggregated fields from the table: "enum_calculator" */
  enum_calculator_aggregate: Enum_Calculator_Aggregate;
  /** fetch data from the table: "enum_calculator" using primary key columns */
  enum_calculator_by_pk?: Maybe<Enum_Calculator>;
  /** fetch data from the table in a streaming manner: "enum_calculator" */
  enum_calculator_stream: Array<Enum_Calculator>;
  /** fetch data from the table: "enum_measurement_system" */
  enum_measurement_system: Array<Enum_Measurement_System>;
  /** fetch aggregated fields from the table: "enum_measurement_system" */
  enum_measurement_system_aggregate: Enum_Measurement_System_Aggregate;
  /** fetch data from the table: "enum_measurement_system" using primary key columns */
  enum_measurement_system_by_pk?: Maybe<Enum_Measurement_System>;
  /** fetch data from the table in a streaming manner: "enum_measurement_system" */
  enum_measurement_system_stream: Array<Enum_Measurement_System>;
  /** fetch data from the table: "enum_user_role" */
  enum_user_role: Array<Enum_User_Role>;
  /** fetch aggregated fields from the table: "enum_user_role" */
  enum_user_role_aggregate: Enum_User_Role_Aggregate;
  /** fetch data from the table: "enum_user_role" using primary key columns */
  enum_user_role_by_pk?: Maybe<Enum_User_Role>;
  /** fetch data from the table in a streaming manner: "enum_user_role" */
  enum_user_role_stream: Array<Enum_User_Role>;
  /** fetch data from the table: "farm" */
  farm: Array<Farm>;
  /** fetch aggregated fields from the table: "farm" */
  farm_aggregate: Farm_Aggregate;
  /** fetch data from the table: "farm" using primary key columns */
  farm_by_pk?: Maybe<Farm>;
  /** fetch data from the table in a streaming manner: "farm" */
  farm_stream: Array<Farm>;
  /** fetch data from the table: "report" */
  report: Array<Report>;
  /** fetch aggregated fields from the table: "report" */
  report_aggregate: Report_Aggregate;
  /** fetch data from the table: "report" using primary key columns */
  report_by_pk?: Maybe<Report>;
  /** fetch data from the table in a streaming manner: "report" */
  report_stream: Array<Report>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table in a streaming manner: "user" */
  user_stream: Array<User>;
};


export type Subscription_RootCalculationArgs = {
  distinct_on?: Maybe<Array<Calculation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Calculation_Order_By>>;
  where?: Maybe<Calculation_Bool_Exp>;
};


export type Subscription_RootCalculation_AggregateArgs = {
  distinct_on?: Maybe<Array<Calculation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Calculation_Order_By>>;
  where?: Maybe<Calculation_Bool_Exp>;
};


export type Subscription_RootCalculation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCalculation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Calculation_Stream_Cursor_Input>>;
  where?: Maybe<Calculation_Bool_Exp>;
};


export type Subscription_RootCalfArgs = {
  distinct_on?: Maybe<Array<Calf_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Calf_Order_By>>;
  where?: Maybe<Calf_Bool_Exp>;
};


export type Subscription_RootCalf_AggregateArgs = {
  distinct_on?: Maybe<Array<Calf_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Calf_Order_By>>;
  where?: Maybe<Calf_Bool_Exp>;
};


export type Subscription_RootCalf_By_PkArgs = {
  system_id: Scalars['uuid'];
};


export type Subscription_RootCalf_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Calf_Stream_Cursor_Input>>;
  where?: Maybe<Calf_Bool_Exp>;
};


export type Subscription_RootEnum_CalculatorArgs = {
  distinct_on?: Maybe<Array<Enum_Calculator_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_Calculator_Order_By>>;
  where?: Maybe<Enum_Calculator_Bool_Exp>;
};


export type Subscription_RootEnum_Calculator_AggregateArgs = {
  distinct_on?: Maybe<Array<Enum_Calculator_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_Calculator_Order_By>>;
  where?: Maybe<Enum_Calculator_Bool_Exp>;
};


export type Subscription_RootEnum_Calculator_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEnum_Calculator_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Enum_Calculator_Stream_Cursor_Input>>;
  where?: Maybe<Enum_Calculator_Bool_Exp>;
};


export type Subscription_RootEnum_Measurement_SystemArgs = {
  distinct_on?: Maybe<Array<Enum_Measurement_System_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_Measurement_System_Order_By>>;
  where?: Maybe<Enum_Measurement_System_Bool_Exp>;
};


export type Subscription_RootEnum_Measurement_System_AggregateArgs = {
  distinct_on?: Maybe<Array<Enum_Measurement_System_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_Measurement_System_Order_By>>;
  where?: Maybe<Enum_Measurement_System_Bool_Exp>;
};


export type Subscription_RootEnum_Measurement_System_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootEnum_Measurement_System_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Enum_Measurement_System_Stream_Cursor_Input>>;
  where?: Maybe<Enum_Measurement_System_Bool_Exp>;
};


export type Subscription_RootEnum_User_RoleArgs = {
  distinct_on?: Maybe<Array<Enum_User_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_User_Role_Order_By>>;
  where?: Maybe<Enum_User_Role_Bool_Exp>;
};


export type Subscription_RootEnum_User_Role_AggregateArgs = {
  distinct_on?: Maybe<Array<Enum_User_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enum_User_Role_Order_By>>;
  where?: Maybe<Enum_User_Role_Bool_Exp>;
};


export type Subscription_RootEnum_User_Role_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEnum_User_Role_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Enum_User_Role_Stream_Cursor_Input>>;
  where?: Maybe<Enum_User_Role_Bool_Exp>;
};


export type Subscription_RootFarmArgs = {
  distinct_on?: Maybe<Array<Farm_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Farm_Order_By>>;
  where?: Maybe<Farm_Bool_Exp>;
};


export type Subscription_RootFarm_AggregateArgs = {
  distinct_on?: Maybe<Array<Farm_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Farm_Order_By>>;
  where?: Maybe<Farm_Bool_Exp>;
};


export type Subscription_RootFarm_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFarm_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Farm_Stream_Cursor_Input>>;
  where?: Maybe<Farm_Bool_Exp>;
};


export type Subscription_RootReportArgs = {
  distinct_on?: Maybe<Array<Report_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Report_Order_By>>;
  where?: Maybe<Report_Bool_Exp>;
};


export type Subscription_RootReport_AggregateArgs = {
  distinct_on?: Maybe<Array<Report_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Report_Order_By>>;
  where?: Maybe<Report_Bool_Exp>;
};


export type Subscription_RootReport_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootReport_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Report_Stream_Cursor_Input>>;
  where?: Maybe<Report_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  distinct_on?: Maybe<Array<User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Order_By>>;
  where?: Maybe<User_Bool_Exp>;
};


export type Subscription_RootUser_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Order_By>>;
  where?: Maybe<User_Bool_Exp>;
};


export type Subscription_RootUser_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Stream_Cursor_Input>>;
  where?: Maybe<User_Bool_Exp>;
};


/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};

/** Users' table */
export type User = {
  __typename?: 'user';
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  created_by: Array<Farm>;
  /** An aggregate relationship */
  created_by_aggregate: Farm_Aggregate;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_login_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  last_name?: Maybe<Scalars['String']>;
  pingfederate_uid?: Maybe<Scalars['String']>;
  role?: Maybe<Enum_User_Role_Enum>;
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  updated_by: Array<Farm>;
  /** An aggregate relationship */
  updated_by_aggregate: Farm_Aggregate;
  /** An object relationship */
  user_role?: Maybe<Enum_User_Role>;
};


/** Users' table */
export type UserCreated_ByArgs = {
  distinct_on?: Maybe<Array<Farm_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Farm_Order_By>>;
  where?: Maybe<Farm_Bool_Exp>;
};


/** Users' table */
export type UserCreated_By_AggregateArgs = {
  distinct_on?: Maybe<Array<Farm_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Farm_Order_By>>;
  where?: Maybe<Farm_Bool_Exp>;
};


/** Users' table */
export type UserUpdated_ByArgs = {
  distinct_on?: Maybe<Array<Farm_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Farm_Order_By>>;
  where?: Maybe<Farm_Bool_Exp>;
};


/** Users' table */
export type UserUpdated_By_AggregateArgs = {
  distinct_on?: Maybe<Array<Farm_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Farm_Order_By>>;
  where?: Maybe<Farm_Bool_Exp>;
};

/** aggregated selection of "user" */
export type User_Aggregate = {
  __typename?: 'user_aggregate';
  aggregate?: Maybe<User_Aggregate_Fields>;
  nodes: Array<User>;
};

/** aggregate fields of "user" */
export type User_Aggregate_Fields = {
  __typename?: 'user_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Max_Fields>;
  min?: Maybe<User_Min_Fields>;
};


/** aggregate fields of "user" */
export type User_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  _and?: Maybe<Array<User_Bool_Exp>>;
  _not?: Maybe<User_Bool_Exp>;
  _or?: Maybe<Array<User_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Farm_Bool_Exp>;
  created_by_aggregate?: Maybe<Farm_Aggregate_Bool_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  first_login_at?: Maybe<Timestamptz_Comparison_Exp>;
  first_name?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  last_name?: Maybe<String_Comparison_Exp>;
  pingfederate_uid?: Maybe<String_Comparison_Exp>;
  role?: Maybe<Enum_User_Role_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_by?: Maybe<Farm_Bool_Exp>;
  updated_by_aggregate?: Maybe<Farm_Aggregate_Bool_Exp>;
  user_role?: Maybe<Enum_User_Role_Bool_Exp>;
};

/** unique or primary key constraints on table "user" */
export enum User_Constraint {
  /** unique or primary key constraint on columns "email" */
  UserEmailKey = 'user_email_key',
  /** unique or primary key constraint on columns "pingfederate_uid" */
  UserPingfederateUidKey = 'user_pingfederate_uid_key',
  /** unique or primary key constraint on columns "id" */
  UserPkey = 'user_pkey'
}

/** input type for inserting data into table "user" */
export type User_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Farm_Arr_Rel_Insert_Input>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_login_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  pingfederate_uid?: Maybe<Scalars['String']>;
  role?: Maybe<Enum_User_Role_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Farm_Arr_Rel_Insert_Input>;
  user_role?: Maybe<Enum_User_Role_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Max_Fields = {
  __typename?: 'user_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_login_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  pingfederate_uid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type User_Min_Fields = {
  __typename?: 'user_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_login_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  pingfederate_uid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "user" */
export type User_Mutation_Response = {
  __typename?: 'user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** input type for inserting object relation for remote table "user" */
export type User_Obj_Rel_Insert_Input = {
  data: User_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<User_On_Conflict>;
};

/** on_conflict condition type for table "user" */
export type User_On_Conflict = {
  constraint: User_Constraint;
  update_columns?: Array<User_Update_Column>;
  where?: Maybe<User_Bool_Exp>;
};

/** Ordering options when selecting data from "user". */
export type User_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by_aggregate?: Maybe<Farm_Aggregate_Order_By>;
  deleted_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  first_login_at?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  pingfederate_uid?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by_aggregate?: Maybe<Farm_Aggregate_Order_By>;
  user_role?: Maybe<Enum_User_Role_Order_By>;
};

/** primary key columns input for table: user */
export type User_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user" */
export enum User_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstLoginAt = 'first_login_at',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PingfederateUid = 'pingfederate_uid',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "user" */
export type User_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_login_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  pingfederate_uid?: Maybe<Scalars['String']>;
  role?: Maybe<Enum_User_Role_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "user" */
export type User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_login_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  pingfederate_uid?: Maybe<Scalars['String']>;
  role?: Maybe<Enum_User_Role_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "user" */
export enum User_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstLoginAt = 'first_login_at',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PingfederateUid = 'pingfederate_uid',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type User_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Bool_Exp;
};


/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
};

export type AddCalculationMutationVariables = Exact<{
  object: Calculation_Insert_Input;
}>;


export type AddCalculationMutation = (
  { __typename?: 'mutation_root' }
  & { insert_calculation_one?: Maybe<(
    { __typename?: 'calculation' }
    & Pick<Calculation, 'id' | 'inputs' | 'name'>
  )> }
);

export type AddFarmMutationVariables = Exact<{
  address_line_1?: Maybe<Scalars['String']>;
  zipcode: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  manager_phone?: Maybe<Scalars['String']>;
  manager_name?: Maybe<Scalars['String']>;
  manager_email?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
}>;


export type AddFarmMutation = (
  { __typename?: 'mutation_root' }
  & { insert_farm_one?: Maybe<(
    { __typename?: 'farm' }
    & Pick<Farm, 'address_line_1' | 'address_line_2' | 'city' | 'id' | 'manager_email' | 'manager_name' | 'manager_phone' | 'name' | 'state' | 'zipcode'>
  )> }
);

export type DeleteCalculationMutationVariables = Exact<{
  calculation_id: Scalars['uuid'];
}>;


export type DeleteCalculationMutation = (
  { __typename?: 'mutation_root' }
  & { delete_calculation_by_pk?: Maybe<(
    { __typename?: 'calculation' }
    & Pick<Calculation, 'id'>
  )> }
);

export type DeleteCalfByPkMutationVariables = Exact<{
  system_id: Scalars['uuid'];
}>;


export type DeleteCalfByPkMutation = (
  { __typename?: 'mutation_root' }
  & { update_calf_by_pk?: Maybe<(
    { __typename?: 'calf' }
    & Pick<Calf, 'system_id' | 'id'>
  )> }
);

export type DeleteFarmByPkMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteFarmByPkMutation = (
  { __typename?: 'mutation_root' }
  & { update_farm_by_pk?: Maybe<(
    { __typename?: 'farm' }
    & Pick<Farm, 'id' | 'updated_at'>
  )> }
);

export type GenerateColostrumReplacerReportMutationVariables = Exact<{
  data: Scalars['String'];
}>;


export type GenerateColostrumReplacerReportMutation = (
  { __typename?: 'mutation_root' }
  & { generateColostrumReplacerReport?: Maybe<(
    { __typename?: 'GenerateReportOutput' }
    & Pick<GenerateReportOutput, 'fileName' | 'report_url' | 's3_key'>
  )> }
);

export type GenerateReportMutationVariables = Exact<{
  data: Scalars['String'];
}>;


export type GenerateReportMutation = (
  { __typename?: 'mutation_root' }
  & { generateReport?: Maybe<(
    { __typename?: 'GenerateReportOutput' }
    & Pick<GenerateReportOutput, 's3_key' | 'report_url' | 'fileName'>
  )> }
);

export type InsertOrUpdateCalfMutationVariables = Exact<{
  object: Calf_Insert_Input;
}>;


export type InsertOrUpdateCalfMutation = (
  { __typename?: 'mutation_root' }
  & { insert_calf_one?: Maybe<(
    { __typename?: 'calf' }
    & Pick<Calf, 'id' | 'system_id'>
  )> }
);

export type ModuleRequestAccessMutationVariables = Exact<{
  module: ModuleRequestAccessEnum;
}>;


export type ModuleRequestAccessMutation = (
  { __typename?: 'mutation_root' }
  & { moduleRequestAccess?: Maybe<(
    { __typename?: 'ModuleRequestAccessOutput' }
    & Pick<ModuleRequestAccessOutput, 'status'>
  )> }
);

export type UpdateFarmByPkMutationVariables = Exact<{
  id: Scalars['uuid'];
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  manager_email?: Maybe<Scalars['String']>;
  manager_name?: Maybe<Scalars['String']>;
  manager_phone?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  zipcode: Scalars['String'];
}>;


export type UpdateFarmByPkMutation = (
  { __typename?: 'mutation_root' }
  & { update_farm_by_pk?: Maybe<(
    { __typename?: 'farm' }
    & Pick<Farm, 'address_line_1' | 'address_line_2' | 'city' | 'id' | 'manager_email' | 'manager_name' | 'manager_phone' | 'name' | 'state' | 'zipcode'>
  )> }
);

export type UpdateFarmCalculationValuesMutationVariables = Exact<{
  id: Scalars['uuid'];
  feedings_per_day: Scalars['numeric'];
  calves_count: Scalars['Int'];
}>;


export type UpdateFarmCalculationValuesMutation = (
  { __typename?: 'mutation_root' }
  & { update_farm_by_pk?: Maybe<(
    { __typename?: 'farm' }
    & Pick<Farm, 'id' | 'feedings_per_day' | 'calves_count'>
  )> }
);

export type UpdateFarmIsPoolingMutationVariables = Exact<{
  id: Scalars['uuid'];
  col_rep_is_pooling: Scalars['Boolean'];
}>;


export type UpdateFarmIsPoolingMutation = (
  { __typename?: 'mutation_root' }
  & { update_farm_by_pk?: Maybe<(
    { __typename?: 'farm' }
    & Pick<Farm, 'id'>
  )> }
);

export type UpdateFarmSettingsMutationVariables = Exact<{
  id: Scalars['uuid'];
  col_rep_measurement_system_id: Enum_Measurement_System_Enum;
  colostrum_max_first_fdg: Scalars['numeric'];
  colostrum_max_second_fdg: Scalars['numeric'];
}>;


export type UpdateFarmSettingsMutation = (
  { __typename?: 'mutation_root' }
  & { update_farm_by_pk?: Maybe<(
    { __typename?: 'farm' }
    & Pick<Farm, 'id'>
  )> }
);

export type AllCalvesHistoryQueryVariables = Exact<{
  farmId: Scalars['uuid'];
}>;


export type AllCalvesHistoryQuery = (
  { __typename?: 'query_root' }
  & { calf: Array<(
    { __typename?: 'calf' }
    & Pick<Calf, 'birth_body_wt' | 'col_rep_measurement_system_id' | 'colostrum_first_fdg_brix_reading' | 'colostrum_max_first_fdg' | 'colostrum_max_second_fdg' | 'colostrum_second_fdg_brix_reading' | 'farm_id' | 'id' | 'system_id' | 'created_at'>
  )>, farm_by_pk?: Maybe<(
    { __typename?: 'farm' }
    & Pick<Farm, 'id' | 'name'>
  )>, getIgGInColostrumReplacer?: Maybe<(
    { __typename?: 'GetIgGInColostrumReplacerOutput' }
    & Pick<GetIgGInColostrumReplacerOutput, 'igGInColostrumReplacer'>
  )> }
);

export type AllFarmsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllFarmsQuery = (
  { __typename?: 'query_root' }
  & { farm: Array<(
    { __typename?: 'farm' }
    & Pick<Farm, 'address_line_1' | 'address_line_2' | 'city' | 'id' | 'manager_email' | 'manager_name' | 'manager_phone' | 'name' | 'state' | 'zipcode'>
  )> }
);

export type AllPooledCalculationsQueryVariables = Exact<{
  farmId: Scalars['uuid'];
}>;


export type AllPooledCalculationsQuery = (
  { __typename?: 'query_root' }
  & { calculation: Array<(
    { __typename?: 'calculation' }
    & Pick<Calculation, 'id' | 'inputs' | 'name' | 'created_at'>
  )>, farm_by_pk?: Maybe<(
    { __typename?: 'farm' }
    & Pick<Farm, 'id' | 'name' | 'colostrum_max_second_fdg' | 'col_rep_measurement_system_id' | 'colostrum_max_first_fdg'>
  )> }
);

export type CalculationsOfFarmQueryVariables = Exact<{
  farm_id: Scalars['uuid'];
}>;


export type CalculationsOfFarmQuery = (
  { __typename?: 'query_root' }
  & { calculation: Array<(
    { __typename?: 'calculation' }
    & Pick<Calculation, 'id' | 'name' | 'farm_id' | 'inputs' | 'created_at' | 'calculator'>
    & { farm: (
      { __typename?: 'farm' }
      & Pick<Farm, 'id' | 'name'>
    ) }
  )> }
);

export type CalfByPkQueryVariables = Exact<{
  system_id: Scalars['uuid'];
}>;


export type CalfByPkQuery = (
  { __typename?: 'query_root' }
  & { calf_by_pk?: Maybe<(
    { __typename?: 'calf' }
    & Pick<Calf, 'birth_body_wt' | 'colostrum_first_fdg_brix_reading' | 'colostrum_second_fdg_brix_reading' | 'id' | 'system_id'>
  )> }
);

export type CalfListByFarmIdQueryVariables = Exact<{
  farmId: Scalars['uuid'];
}>;


export type CalfListByFarmIdQuery = (
  { __typename?: 'query_root' }
  & { calf: Array<(
    { __typename?: 'calf' }
    & Pick<Calf, 'id' | 'system_id' | 'col_rep_measurement_system_id' | 'colostrum_max_first_fdg' | 'colostrum_max_second_fdg' | 'colostrum_first_fdg_brix_reading' | 'colostrum_second_fdg_brix_reading' | 'birth_body_wt'>
  )>, farm_by_pk?: Maybe<(
    { __typename?: 'farm' }
    & Pick<Farm, 'id' | 'col_rep_measurement_system_id' | 'colostrum_max_first_fdg' | 'colostrum_max_second_fdg'>
  )>, getIgGInColostrumReplacer?: Maybe<(
    { __typename?: 'GetIgGInColostrumReplacerOutput' }
    & Pick<GetIgGInColostrumReplacerOutput, 'igGInColostrumReplacer'>
  )> }
);

export type CheckIsCalfAlreadyExistQueryVariables = Exact<{
  id: Scalars['String'];
  farmId: Scalars['uuid'];
}>;


export type CheckIsCalfAlreadyExistQuery = (
  { __typename?: 'query_root' }
  & { calf: Array<(
    { __typename?: 'calf' }
    & Pick<Calf, 'id' | 'system_id'>
  )> }
);

export type FarmOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FarmOptionsQuery = (
  { __typename?: 'query_root' }
  & { farm: Array<(
    { __typename?: 'farm' }
    & Pick<Farm, 'id' | 'name' | 'calves_count' | 'feedings_per_day' | 'col_rep_measurement_system_id' | 'colostrum_max_first_fdg' | 'colostrum_max_second_fdg' | 'col_rep_is_pooling'>
  )> }
);

export type FarmSettingsByFarmIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type FarmSettingsByFarmIdQuery = (
  { __typename?: 'query_root' }
  & { farm_by_pk?: Maybe<(
    { __typename?: 'farm' }
    & Pick<Farm, 'id' | 'col_rep_measurement_system_id' | 'colostrum_max_first_fdg' | 'colostrum_max_second_fdg'>
  )>, calculation: Array<(
    { __typename?: 'calculation' }
    & Pick<Calculation, 'id' | 'inputs'>
  )>, getIgGInColostrumReplacer?: Maybe<(
    { __typename?: 'GetIgGInColostrumReplacerOutput' }
    & Pick<GetIgGInColostrumReplacerOutput, 'igGInColostrumReplacer'>
  )> }
);
